import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import globals from '../globals'
import Documents from '../modules/Documents'
import SubNavigation from '../modules/SubNavigation'
import RateCard from '../modules/RateCard'
import ReplaceSim from '../modules/ReplaceSim'
import DataSource from '../DataSource'
import CancelMobileService from '../modules/CancelMobileService'
import GlobalRoaming from '../modules/GlobalRoaming'
import PremiumSms from '../modules/PremiumSms'
import CapMySpend from '../modules/CapMySpend'
import { NETWORK_TELSTRA, SERVICE_MOBILE } from '../constants'
import UsageSummary from '../modules/UsageSummary'
import DetailedUsage from '../modules/DetailedUsage'
import ServiceHeading from '../modules/ServiceHeading'
import InterimPayment from '../modules/InterimPayment'
import CustomLink from '../components/CustomLink'
import RechargeNow from '../modules/RechargeNow'
import ManageMobileAddOns from '../modules/ManageMobileAddOns'
import RechargeHistory from '../modules/RechargeHistory'
import ZeroDataRecharge from '../modules/ZeroDataRecharge'
import CancelTelstraService from '../modules/CancelTelstraService'
import RateCardTelstra from '../modules/RateCardTelstra'
import AjaxLoader from '../components/AjaxLoader'
import ServiceDetailsAddress from '../modules/ServiceDetailsAddress'

class MobileService extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
		    isLoaded: false,
            hasErrors: false,
            serviceId: parseInt(this.props.match.params.id),
            serviceDetails: {},
            subNav: []
        }

        this.type = SERVICE_MOBILE
    }

    componentDidMount () {
	    this.getData()
    }

    getData (firstLoad = true) {
        DataSource.getData(`/api/getService/${this.type}/${this.state.serviceId}`, result => {
            this.setSubNav(result.networkProvider)
            this.setState({
                serviceDetails: { ...result, ...result.serviceDetails },
                isLoaded: true
            })
            if (firstLoad) {
                globals.animatePageIn(this.container)
            }
        }, () => {
            this.setState({ isLoaded: true, hasErrors: true })
        })
    }

    getUrl (url) {
        return `/my-services/${this.type}/${this.state.serviceId}/${url}`
    }

    isTelstra () {
	    return this.state.serviceDetails && this.state.serviceDetails.networkProvider === NETWORK_TELSTRA
    }

    setSubNav (networkProvider) {
	    let subNav
	    if (networkProvider === NETWORK_TELSTRA) {
	        subNav = [
                { title: 'My usage', url: '' },
                { title: 'Manage recharge', url: '/recharge' },
                { title: 'Zero data auto-recharge', url: '/zero-data-recharge' },
                { title: 'Recharge & Add-on history', url: '/recharge-history' },
                { title: 'Service details', url: '/service-details' },
                { title: 'Manage Add-ons', url: '/manage-add-ons' },
                { title: 'Replace SIM', url: '/replace-sim' },
                { title: 'Detailed usage', url: '/detailed-usage' },
                { title: 'My rate card', url: '/my-rate-card' },
                { title: 'My documents', url: '/my-documents' },
                { title: 'Global roaming', url: '/global-roaming' },
                { title: 'Cancel my service', url: '/cancel-service' }
            ]
        } else {
	        subNav = [
                { title: 'Usage summary', url: '' },
                { title: 'Detailed usage', url: '/detailed-usage' },
                { title: 'Service details', url: '/service-details' },
                { title: 'My rate card', url: '/my-rate-card' },
                { title: 'Replace SIM', url: '/replace-sim' },
                { title: 'Global roaming', url: '/global-roaming' },
                { title: 'Premium SMS', url: '/premium-sms' },
                { title: 'My documents', url: '/my-documents' },
                { title: 'Cap my spend', url: '/cap-my-spend' },
                { title: 'Cancel my service', url: '/cancel-service' }
            ]
        }

	    this.setState({ subNav: subNav })
    }

    render () {
        const RenderMyUsage = () => {
            return (
                <UsageSummary
                    type={this.type}
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                    getUrl={this.getUrl.bind(this)}
                    isTelstra={this.isTelstra()}
                />
            )
        }

        const RenderDetailedUsage = () => {
		    return (
    <DetailedUsage
                    type={this.type}
                    serviceId={this.state.serviceId}
                />
            )
        }

        const RenderServiceDetails = () => {
		    return (
    <ServiceDetailsAddress
                    serviceId={this.state.serviceId}
                    ipndStatus={this.state.serviceDetails.ipndStatus}
                    serviceAddress={this.state.serviceDetails.serviceAddress}
                    details={this.state.serviceDetails.data}
                    updateServiceDetails={() => this.getData(false)}
                />
            )
        }

        const RenderDocuments = () => {
            return (
                <Documents
                    title='My documents'
                    type={this.type}
                    serviceId={this.state.serviceId}
                />
            )
        }

        const RenderReplaceSim = () => {
            return (
                <ReplaceSim
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                />
            )
        }

        const RenderCancelMobileService = () => {
            return (
                <CancelMobileService
                    title='Cancel my service'
                    type={this.type}
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                />
            )
        }

        const RenderGlobalRoaming = () => {
            return (
                <GlobalRoaming
                    title='Global roaming'
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                    mobile={this.state.serviceDetails.address}
                />
            )
        }

        const RenderPremiumSms = () => {
            return (
                <PremiumSms
                    title='Premium SMS'
                    serviceId={this.state.serviceId}
                />
            )
        }

        const RenderCapMySpend = () => {
            return (
                <CapMySpend
                    title='Cap my spend'
                    serviceId={this.state.serviceId}
                    cappedSpend={this.state.serviceDetails.cappedSpend}
                />
            )
        }

        const RenderRateCard = () => {
            return (
                <RateCard
                    serviceId={this.state.serviceId}
                />
            )
        }

        const RenderInterimPayment = () => {
            return (
                <InterimPayment
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                />
            )
        }

        const RenderRateCardTelstra = () => {
            return <RateCardTelstra />
        }

        const RenderRecharge = () => {
            return (
                <RechargeNow
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                    updateServiceDetails={this.getData.bind(this)}
                />
            )
        }

        const RenderManageAddOns = () => {
            return (
                <ManageMobileAddOns
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                    updateServiceDetails={this.getData.bind(this)}
                />
            )
        }

        const RenderRechargeHistory = () => {
            return (
                <RechargeHistory
                    serviceId={this.state.serviceId}
                />
            )
        }

        const RenderCancelTelstraService = () => {
            return (
                <CancelTelstraService
                    serviceId={this.state.serviceId}
                />
            )
        }

        const RenderZeroDataRecharge = () => {
            return (
                <ZeroDataRecharge
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                    updateServiceDetails={this.getData.bind(this)}
                />
            )
        }

        if (!this.state.isLoaded) {
            return <AjaxLoader />
        }

        if (this.state.hasErrors) {
            return <Redirect push to='/' />
        }

        return (
            <div ref={el => this.container = el} style={{ opacity: 0 }}>
                <ServiceHeading
                    type={this.type}
                    icon='/images/icon-mobile.svg'
                    smallText={this.state.serviceDetails.serviceNo}
                    medText={this.state.serviceDetails.description}
                    colClassLg='col-lg-4'
                >
                    {!this.isTelstra()
                        ? <div className='col-12 col-lg-8 d-flex align-items-center justify-content-lg-end'>
                            <div className='d-lg-flex align-items-center text-center text-lg-left'>
                                <div className='my-3 my-lg-0 mr-lg-2'>
                                    <p className='m-0 font-small'>Migrate this service now and open up new world of BIG data allowances, loads of upfront migration bonus data, as well as heaps of awesome plan features like Data Rollover.</p>
                                </div>
                                <div style={{ whiteSpace: 'nowrap' }}>
                                    <CustomLink to='/migrate-mobile' className='btn btn-custom mb-2'>Migrate & activate my SIM(s)</CustomLink>
                                </div>
                            </div>
                          </div>
                        : ''}
                </ServiceHeading>

                {!this.props.location.pathname.includes('/interim-payment')
                    ? <SubNavigation
                            title='Manage my service'
                            items={this.state.subNav}
                            url={this.props.match.url}
                            className='gtm-service-manage-tab-click min-w-25'
                      />
                    : ''}

                {this.isTelstra()
                    ? <Switch>
                        <Route exact path={this.props.match.url} render={RenderMyUsage} />
                        <Route exact path={`${this.props.match.url}/detailed-usage`} render={RenderDetailedUsage} />
                        <Route exact path={`${this.props.match.url}/service-details`} render={RenderServiceDetails} />
                        <Route exact path={`${this.props.match.url}/my-documents`} render={RenderDocuments} />
                        <Route exact path={`${this.props.match.url}/my-rate-card`} render={RenderRateCardTelstra} />
                        <Route exact path={`${this.props.match.url}/replace-sim`} render={RenderReplaceSim} />
                        <Route exact path={`${this.props.match.url}/global-roaming`} render={RenderGlobalRoaming} />
                        <Route exact path={`${this.props.match.url}/recharge`} render={RenderRecharge} />
                        <Route exact path={`${this.props.match.url}/manage-add-ons`} render={RenderManageAddOns} />
                        <Route exact path={`${this.props.match.url}/recharge-history`} render={RenderRechargeHistory} />
                        <Route exact path={`${this.props.match.url}/zero-data-recharge`} render={RenderZeroDataRecharge} />
                        <Route exact path={`${this.props.match.url}/cancel-service`} render={RenderCancelTelstraService} />
                      </Switch>
                    : <Switch>
                        <Route exact path={this.props.match.url} render={RenderMyUsage} />
                        <Route exact path={`${this.props.match.url}/detailed-usage`} render={RenderDetailedUsage} />
                        <Route exact path={`${this.props.match.url}/service-details`} render={RenderServiceDetails} />
                        <Route exact path={`${this.props.match.url}/my-documents`} render={RenderDocuments} />
                        <Route exact path={`${this.props.match.url}/my-rate-card`} render={RenderRateCard} />
                        <Route exact path={`${this.props.match.url}/replace-sim`} render={RenderReplaceSim} />
                        <Route exact path={`${this.props.match.url}/cancel-service`} render={RenderCancelMobileService} />
                        <Route exact path={`${this.props.match.url}/global-roaming`} render={RenderGlobalRoaming} />
                        <Route exact path={`${this.props.match.url}/premium-sms`} render={RenderPremiumSms} />
                        <Route exact path={`${this.props.match.url}/cap-my-spend`} render={RenderCapMySpend} />
                        <Route exact path={`${this.props.match.url}/interim-payment`} render={RenderInterimPayment} />
                      </Switch>}
            </div>
        )
    }
}

export default MobileService



// WEBPACK FOOTER //
// ./resources/js/services/MobileService.js